import type { Moment } from 'moment';
import moment from 'moment';

export const isWeekend = (date: moment.Moment) => {
  const dayOfWeek = date.day();
  return dayOfWeek === 0 || dayOfWeek === 6;
};

export const getWeekendsCount = (
  startDate: moment.Moment,
  endDate: moment.Moment,
): number => {
  const daysCount = Math.ceil(endDate.diff(startDate, 'hour') / 24);
  return Array.from({ length: daysCount }, (_, i) =>
    isWeekend(startDate.clone().add(i, 'days')),
  ).filter((item) => item).length;
};

export const isOnlyRegularDays = (
  startDate: moment.Moment,
  endDate: moment.Moment,
): boolean => {
  if (!startDate || !endDate) {
    return false;
  }

  const daysCount = Math.ceil(endDate.diff(startDate, 'hour') / 24);

  return Array.from({ length: daysCount }, (_, i) =>
    isWeekend(startDate.clone().add(i, 'days')),
  ).every((isWeekendDay) => !isWeekendDay);
};

export const generateMonthsArrayByN = (n: number) => {
  const currentDate = moment();
  return Array.from({ length: n }).map(() => {
    const clonedDate = moment(currentDate);
    currentDate.add(1, 'month');
    return clonedDate;
  });
};

export const isAfterSomeHour = (
  date: Moment,
  targetHour: number,
  targetMinute: number = 0,
): boolean => {
  if (!date || !date.isValid() || isNaN(targetHour) || isNaN(targetMinute)) {
    throw new Error('Invalid date, hour, or minute.');
  }

  const dateHour = date.hour();
  const dateMinute = date.minutes();

  return dateHour > targetHour
    ? true
    : dateHour === targetHour
      ? dateMinute > targetMinute
      : false;
};

export const getDaysCount = (startDate: Moment, endDate: Moment) => {
  return Math.ceil(moment(endDate).diff(moment(startDate), 'hour') / 24);
};
